import { render, staticRenderFns } from "./AddPatientForm.vue?vue&type=template&id=b8b5aee0"
import script from "./AddPatientForm.vue?vue&type=script&lang=js"
export * from "./AddPatientForm.vue?vue&type=script&lang=js"
import style0 from "./AddPatientForm.vue?vue&type=style&index=0&id=b8b5aee0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports